import React, { Fragment } from "react";
import Moment from "react-moment";

let formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const ProfileAppStatus = ({
  setShowAppliedJobs,
  profile: { avatar, firstname, lastname, jobtitle, location, appliedjobs },
}) => {
  return (
    <Fragment>
      <div className="modal-overlay">
        <div className="app-status">
          <i
            className="fas fa-times fa-2x message-x"
            onClick={() => setShowAppliedJobs(false)}
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div className="avi-color-border green">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="drop-down-result-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="green name-font bold">
                    {firstname} {lastname}
                  </span>
                </li>
                <li className="user-online-item">{jobtitle}</li>
                <li className="user-online-item">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          {appliedjobs.length <= 0 ? (
            <div className="no-user-content">
              <p className="no-content-message green bold">
                No Current Job Applications
              </p>
            </div>
          ) : (
            <div>
              <div className="user-search-container">
                <div className="article-search-container">
                  <form action="" className="trending-form-flex">
                    <div className="label-input">
                      <label htmlFor="" className="trending-labels green">
                        Search
                        <i className="fas fa-search green mx-5"></i>
                      </label>
                      <div className="input-drop-down">
                        <div className="search-input-hidden">
                          <input
                            className="search-input-style"
                            type="text"
                            name="mentors"
                            placeholder="Enter User Name..."
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="scroll-container-alt">
                {appliedjobs.map((job) => {
                  return (
                    <div className="app-status-section">
                      <div className="app-avi-container">
                        <img
                          src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${job.avatar}`}
                          className="app-avi"
                          alt="app-avatar"
                        />
                      </div>
                      <div className="app-avi-text">
                        <ul>
                          <li className="post-job-title blue">
                            {job.jobtitle}
                          </li>
                          <li className="job-post-li white">
                            {job.companyname}
                          </li>
                          <li className="job-post-li white">{job.location}</li>
                          <ul>
                            <li className="app-status-keywords background-blue">
                              <i className="fas fa-business-time mr-5"></i>
                              {job.employmenttype}
                            </li>
                            <li className="app-status-keywords background-blue">
                              <i className="far fa-money-bill-alt mr-5"></i>
                              {formatter.format(job.salary)}
                            </li>
                            <li className="app-status-keywords background-blue">
                              <i className="far fa-building mr-5"></i>
                              {job.environment}
                            </li>
                          </ul>
                          {job.vrtour !== "" && (
                            <li className="keywords-app-status background-blue">
                              <i className="fas fa-street-view fa-sm black times-sm mx-10"></i>
                            </li>
                          )}
                          {job.jobstream !== "" && (
                            <li className="keywords-app-status background-blue">
                              <i className="fas fa-video fa-sm black times-sm mx-10"></i>
                            </li>
                          )}
                          <li className="job-post-li white">
                            <i className="fas fa-clock bold fa-sm blue times-sm mr-5"></i>
                            <Moment format="MM/DD/YYYY">{job.date}</Moment>
                          </li>
                        </ul>
                      </div>
                      <div className="app-info-container">
                        <ul className="app-items">
                          {job.poststatusopen && (
                            <li className="app-item">
                              <i className="fas fa-business-time green mx-5"></i>
                              Open
                            </li>
                          )}
                          {!job.poststatusopen && (
                            <li className="app-item">
                              <i className="fas fa-business-time red mx-5"></i>
                              Closed
                            </li>
                          )}
                          {job.poststatusopen && (
                            <li>
                              <button className="friend-button background-red">
                                <i className="fas fa-times mx-5"></i>
                                Withdraw App
                              </button>
                            </li>
                          )}
                          {!job.poststatusopen && (
                            <li>
                              <button className="friend-button background-red">
                                <i className="fas fa-times mx-5"></i>
                                Remove
                              </button>
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default ProfileAppStatus;
